module.exports = __webpack_public_path__ + "img/listeBarquette.79939a9b.png";